import service from '@api/config'

export const myJoinList = (data) => {
  return service.request({
    url: `/project/myJoinList`,
    method: 'post',
    data: data
  })
}

// 我发布的项目列表
export const myPublishList = (data) => {
  return service.request({
    url: `/project/myPublishList`,
    method: 'post',
    data: data
  })
}

// 我参与的 标准流程项目 信息查询，status 0,1
export const getNormalProjectInfo = (data) => {
  return service.request({
    url: `/project/getNormalProjectInfo`,
    method: 'post',
    data: data
  })
}
//  获取流标信息原因
export const failReason = (data) => {
  return service.request({
    url: `/project/failReason`,
    method: 'post',
    data: data
  })
}
// 修改获取项目信息
export const getNormalInfo = (data) => {
  return service.request({
    url: `/project/change/getNormalInfo`,
    method: 'post',
    data: data
  })
}
// 修改保存
export const changeSave = (data) => {
  return service.request({
    url: `/project/change/save`,
    method: 'post',
    data: data
  })
}
// 撤销
export const changeCancel = (data) => {
  return service.request({
    url: `/project/change/cancel`,
    method: 'post',
    data: data
  })
}

// 简易流程项目 信息查询
export const getSimpleProjectInfo = (data) => {
  return service.request({
    url: `/project/getSimpleProjectInfo`,
    method: 'post',
    data: data
  })
}
// 我发布的 分页获取简易项目报名人员
export const getProjectSigns = (data) => {
  return service.request({
    url: `/project/getProjectSigns`,
    method: 'post',
    data: data
  })
}

// 我发布的 分页获取简易项目签约人员
export const getProjectAccepts = (data) => {
  return service.request({
    url: `/project/getProjectAccepts`,
    method: 'post',
    data: data
  })
}
// 删除我发布的简易项目
export const delProject = (data) => {
  return service.request({
    url: `/project/del`,
    method: 'post',
    data: data
  })
}
// 我发布的 根据id获取获取简易项目信息
export const getProjectPubInfo = (data) => {
  return service.request({
    url: `/project/getProjectPubInfo`,
    method: 'post',
    data: data
  })
}
//  我发布的简易项目，已招满操作
export const userEnough = (data) => {
  return service.request({
    url: `/project/userEnough`,
    method: 'post',
    data: data
  })
}
//  我发布的 简易项目查看报名人员详细信息
export const getSignDetail = (data) => {
  return service.request({
    url: `/project/getSignDetail`,
    method: 'post',
    data: data
  })
}
// 同意签约
export const agreeAccept = (data) => {
  return service.request({
    url: `/project/agreeAccept`,
    method: 'post',
    data: data
  })
}
//  我发布的 获取是否已进行过完工评价
export const getFinishAssessStatus = (data) => {
  return service.request({
    url: `/project/getFinishAssessStatus`,
    method: 'post',
    data: data
  })
}
//  我发布的 获取是否已进行过中期评价
export const getMidAssessStatus = (data) => {
  return service.request({
    url: `/project/getMidAssessStatus`,
    method: 'post',
    data: data
  })
}
//  我发起的 简易项目发起完工
export const simpleFinish = (data) => {
  return service.request({
    url: `/project/simple/finish`,
    method: 'post',
    data: data
  })
}
//  我发布的 简易项目查看签约人员详细信息
export const getAcceptDetail = (data) => {
  return service.request({
    url: `/project/getAcceptDetail`,
    method: 'post',
    data: data
  })
}
// 根据简易项目id获取完工情况
export const getFinishStatus = (data) => {
  return service.request({
    url: `/project/getFinishStatus`,
    method: 'post',
    data: data
  })
}
// 根据项目id获取投标队伍列表（评标队伍列表）
export const getTenderCompany = (data) => {
  return service.request({
    url: `/bidding/getTenderCompany`,
    method: 'post',
    data: data
  })
}
// 筛选公司
export const selectCompany = (data) => {
  return service.request({
    url: `/bidding/selectCompany`,
    method: 'post',
    data: data
  })
}
// 公布中标结果
export const projectPublicity = (data) => {
  return service.request({
    url: `/bidding/projectPublicity`,
    method: 'post',
    data: data
  })
}
// 根据项目id获取中标队伍列表（公示、竞标队伍列表）
export const getWinCompany = (data) => {
  return service.request({
    url: `/bidding/getWinCompany`,
    method: 'post',
    data: data
  })
}

// 根据投标id查询投标信息（评标、公示、竞标、结束）
export const getCompanyTenderInfo = (data) => {
  return service.request({
    url: `/bidding/getCompanyTenderInfo`,
    method: 'post',
    data: data
  })
}
// 根据项目id查询项目参与人员,分页
export const workersList = (data) => {
  return service.request({
    url: `/bid/workers/list`,
    method: 'post',
    data: data
  })
}
// 删除项目人员
export const workersDel = (data) => {
  return service.request({
    url: `/bid/workers/del`,
    method: 'post',
    data: data
  })
}
// 招标方发起完工
export const completeFinish = (data) => {
  return service.request({
    url: `/project/completeFinish`,
    method: 'post',
    data: data
  })
}

// 投标方发起完工申请
export const finishApply = (data) => {
  return service.request({
    url: `/project/finishApply`,
    method: 'post',
    data: data
  })
}
// 判断接活状态
export const getProjectAcceptFlag = (data) => {
  return service.request({
    url: `/project/getProjectAcceptFlag`,
    method: 'post',
    data: data
  })
}
// 拒绝接标
export const refuse = (data) => {
  return service.request({
    url: `/bid/refuse`,
    method: 'post',
    data: data
  })
}

// 接标
export const accept = (data) => {
  return service.request({
    url: `/bid/accept`,
    method: 'post',
    data: data
  })
}
// 开始施工
export const beginBuild = (data) => {
  return service.request({
    url: `/project/beginBuild`,
    method: 'post',
    data: data
  })
}
// 根据项目id查看是否已发布公告
export const getIsNotice = (data) => {
  return service.request({
    url: `/bidding/getIsNotice`,
    method: 'post',
    data: data
  })
}
// 根据项目id获取已结束项目中标队伍列表
export const getTenderResult = (data) => {
  return service.request({
    url: `/bid/getTenderResult`,
    method: 'post',
    data: data
  })
}
// 根据项目id查看公告内容
export const getNotice = (data) => {
  return service.request({
    url: `/bidding/getNotice`,
    method: 'post',
    data: data
  })
}
// 发布公告
export const projectNotice = (data) => {
  return service.request({
    url: `/bidding/projectNotice`,
    method: 'post',
    data: data
  })
}
// 判断是否已报名
export const getProjectTenderFlag = (data) => {
  return service.request({
    url: `/project/getProjectTenderFlag`,
    method: 'post',
    data: data
  })
}
// 查看投标范围内队伍
export const getLimitCompanyList = (data) => {
  return service.request({
    url: `/bidding/getLimitCompanyList`,
    method: 'post',
    data: data
  })
}
// 查看修改后投标范围内队伍
export const changeGetLimitCompanyList = (data) => {
  return service.request({
    url: `/project/change/getLimitCompanyList`,
    method: 'post',
    data: data
  })
}

// 查询当前队伍信息
export const bidGetMyCompany = (data) => {
  return service.request({
    url: `/bid/getMyCompany`,
    method: 'post',
    data: data
  })
}
// 项目投标
export const tender = (data) => {
  return service.request({
    url: `/bid/tender`,
    method: 'post',
    data: data
  })
}
// 项目报名
export const signIn = (data) => {
  return service.request({
    url: `/bid/signIn`,
    method: 'post',
    data: data
  })
}
